/**
 * API 基础地址，优先读取构建环境变量。
 * - 生产环境：.env.production
 * - 测试环境：.env.test
 */
export const API_BASE = process.env.VUE_APP_API_BASE || 'https://test.facepopo.com';

export const API_PREFIX = '/api/v1';
export const BASE = `${API_BASE}${API_PREFIX}`;
